import { use } from "react";
import { useState, useRef, useEffect, memo } from "react";
import DisplayOdd from "../components/DisplayOdd";
import { Tooltip } from "react-tooltip";

const HrGrMatchOdd = ({
  onChildRuleShow,
  eventDetails,
  matchOdds,
  setBetSlipDetails,
  HRGRBook
}) => {
  const showRules = () => {
    onChildRuleShow();
  };
  //console.log("eventDetails->", eventDetails);
  //console.log("matchOdds->", matchOdds);
  const [status, setEventStatus] = useState("OPEN");

  const [horseArray, setHorseArray] = useState([]);
  const [jtText, setJtText] = useState("");
  const [jodiBack, setJodiBack] = useState(0);
  const [jodiLay, setJodiLay] = useState(0);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const showBetSlip = (betType, teamName, sid, rate) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      market_type: "m"
    });
  };

  const showBetSlipJT = (betType, teamName, sid, rate) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      selected_obj: sid,
      odds: rate,
      amount: 0,
      back: jodiBack,
      lay: jodiLay,
      market_type: "jt"
    });
  };

  useEffect(() => {
    setEventStatus(eventDetails.evt_status);
  }, [eventDetails.evt_status]);

  const selectUnsellectHorse = async (
    section_id,
    sort_priority,
    runner_name
  ) => {
    var isfound = false;
    var foundIndex = -1;

    if (horseArray != null && horseArray.length > 0) {
      for (var i = 0; i < horseArray.length; i++) {
        var obj = horseArray[i];
        if (obj.section_id == section_id) {
          isfound = true;
          foundIndex = i;
          break;
        }
      }
    }

    if (horseArray.length < 7) {
      if (isfound == false) {
        let arr = {};
        arr.section_id = section_id;
        arr.sort_priority = sort_priority;
        arr.runner_name = runner_name;
        let oldArray = horseArray;
        oldArray.push(arr);
        setHRListInState(oldArray);
      } else {
        if (foundIndex > -1) {
          let freshArray = [];
          for (let j = 0; j < horseArray.length; j++) {
            let obj = horseArray[j];
            if (obj.section_id !== section_id) {
              freshArray.push(obj);
            }
          }
          setHRListInState(freshArray);
        }
      }
    }
  };

  const getCss = (section_id) => {
    //console.log("horseArray->", horseArray);

    let defaultCss = "ml-2 mr-2 selector";
    if (horseArray != null && horseArray.length > 0) {
      for (var i = 0; i < horseArray.length; i++) {
        var obj = horseArray[i];
        if (obj.section_id == section_id) {
          defaultCss = "ml-2 mr-2 selector selected";
          break;
        }
      }
    }
    //
    return defaultCss;
  };

  const getJtText = () => {
    let jtText = "";

    horseArray.sort((a, b) => a.sort_priority - b.sort_priority);
    if (horseArray != null && horseArray.length > 0) {
      for (var i = 0; i < horseArray.length; i++) {
        var obj = horseArray[i];
        //console.log("obj->", obj);
        //jtText = jtText + obj.runner_name + "+";
        jtText = jtText + obj.sort_priority + "+";
      }
    }
    jtText = jtText.slice(0, -1);
    setJtText(jtText);
  };

  const getJTRate = (brate1, lrate1, brate2, lrate2, type) => {
    var step4B = 0;
    var step4L = 0;
    var returnObj = {};
    returnObj.step4B = step4B;
    returnObj.step4L = step4L;
    if (
      brate1 != undefined &&
      brate1 != null &&
      lrate1 != undefined &&
      lrate1 != null &&
      brate2 != undefined &&
      brate2 != null &&
      lrate2 != undefined &&
      lrate2 != null
    ) {
      if (type == 2) {
        brate1 = eval(brate1 - 1);
        lrate1 = eval(lrate1 - 1);
      }

      brate2 = eval(brate2 - 1);
      lrate2 = eval(lrate2 - 1);

      var setp2B = eval(brate1 + brate2) + eval(2);
      var setp2L = eval(lrate1 + lrate2) + eval(2);

      var setp3B = eval(brate1 * brate2) - eval(1);
      var setp3L = eval(lrate1 * lrate2) - eval(1);

      var step4B = eval(setp3B / setp2B);
      var step4L = eval(setp3L / setp2L);

      if (step4B < 0) {
        //step4B = 0;
      }

      if (step4L < 0) {
        //step4L = 0;
      }

      returnObj.step4B = step4B;
      returnObj.step4L = step4L;
    } else {
      console.log("ERROR IN ODDS");
    }

    return returnObj;
  };

  const getLiveOddBySectionId = (sectionId) => {
    var returnObj = {};
    returnObj.brate1 = 0;
    returnObj.lrate1 = 0;

    const arrOdds = Object.values(matchOdds);

    for (var i = 0; i < arrOdds.length; i++) {
      var obj = arrOdds[i];
      if (obj.sectionId == sectionId) {
        returnObj.brate1 = obj.r1b;
        returnObj.lrate1 = obj.r1l;
        break;
      }
    }
    return returnObj;
  };

  const PrepareJTRate = () => {
    //console.log("PrepareJTRate->", horseArray);
    if (horseArray != null && horseArray.length >= 2) {
      horseArray.sort((a, b) => (a.sort_priority > b.sort_priority ? 1 : -1));
      //horseArray.sort((a, b) => a.sort_priority - b.sort_priority);
      if (horseArray.length >= 2) {
        var brate1 = 0;
        var lrate1 = 0;
        var counter = 1;
        for (var j = 0; j < horseArray.length; j++) {
          var objSel = horseArray[j];
          //console.log("objSel->", objSel.sort_priority);
          var sectionId = objSel.section_id;
          var returnObj = getLiveOddBySectionId(sectionId);

          if (j == 0) {
            brate1 = returnObj.brate1;
            lrate1 = returnObj.lrate1;
          } else {
            counter++;
            var rate = getJTRate(
              brate1,
              lrate1,
              returnObj.brate1,
              returnObj.lrate1,
              counter
            );
            let jodiBack1 = rate.step4B;
            let jodiLay1 = rate.step4L;

            if (jodiBack1 == undefined || jodiBack1 == null || jodiBack1 < 0) {
              jodiBack1 = 0;
            }

            if (jodiLay1 == undefined || jodiLay1 == null || jodiLay1 < 0) {
              jodiLay1 = 0;
            }

            setJodiBack(jodiBack1);
            setJodiLay(jodiLay1);

            brate1 = rate.step4B;
            lrate1 = rate.step4L;

            if (counter == 2) {
              console.log("Jodi->");
              console.log("brate1->", brate1);
              console.log("lrate1->", lrate1);
            }

            if (counter == 3) {
              console.log("Tigari->");
              console.log("brate1->", brate1);
              console.log("lrate1->", lrate1);
            }

            if (counter == 4) {
              console.log("4th->");
              console.log("brate1->", brate1);
              console.log("lrate1->", lrate1);
            }
          }
        }
      }
    }
  };

  const setHRListInState = (list) => {
    setHorseArray([]);
    setTimeout(() => {
      setHorseArray(list);
    }, 0);
  };

  useEffect(() => {
    getJtText();
    PrepareJTRate();
  }, [horseArray]);

  useEffect(() => {
    PrepareJTRate();
  }, [matchOdds, horseArray]);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const ShowBook = (section_id) => {
    let bookAmount = "";
    if (HRGRBook !== null && HRGRBook != undefined && HRGRBook.length > 0) {
      for (let i = 0; i < HRGRBook.length; i++) {
        let obj = HRGRBook[i];
        if (obj.runner_sid == section_id) {
          bookAmount = parseInt(obj.amount);
          break;
        }
      }
    }
    return bookAmount;
    formatTruncate(Math.round(bookAmount));
    //return bookAmount;
  };

  let betfair_runners = eventDetails.betfair_runners;
  //console.log("betfair_runners->", betfair_runners);

  betfair_runners = [...betfair_runners].sort(
    (a, b) => a.is_removed - b.is_removed
  );
  //console.log("betfair_runners->", betfair_runners);
  let r1b3 = 0;
  let r1b2 = 0;
  let r1b = 0;
  let r1l = 0;
  let r1l2 = 0;
  let r1l3 = 0;

  let rate1 = 0;
  let rate2 = 0;
  let rate3 = 0;
  let rate4 = 0;
  let rate5 = 0;
  let rate6 = 0;
  let rowStatus = "ACTIVE";
  let isWinner = 0;

  /*
  const DisplayOdd = memo(({ odd, rate }) => {
    
    const prevOdd = useRef(null);
    const [oddCssValue, setOddCssValue] = useState("full-red");
    const [key, setKey] = useState(0);

    useEffect(() => {
      const curr = Number(odd);
      if(prevOdd.current !== null && prevOdd.current !== curr) {
        setKey(key => key + 1);
      }
      prevOdd.current = curr;
    }, [odd]);

    return (
      <div key={key} className="fade-to-red-05s">
        <span className="price-odd" style={{ fontSize: "19px" }}>
          {odd}
        </span>
        <span className="price-amount">{rate}</span>
      </div>
    );
  });
*/
  function getCurrentStatus(matchOdds, eventDetails, runnerData) {
    //console.log("eventDetails->", eventDetails.evt_status);
    //console.log("matchOdds->", matchOdds);
    let returnObj = {};
    returnObj.status = true;
    returnObj.displayTxt = "";

    if (
      matchOdds !== null &&
      matchOdds !== undefined &&
      matchOdds[runnerData?.section_id]?.event_status == "OPEN"
    ) {
    } else {
      if (
        matchOdds !== null &&
        matchOdds !== undefined &&
        matchOdds[runnerData?.section_id]?.event_status != "OPEN"
      ) {
        returnObj.status = false;
        returnObj.displayTxt = matchOdds[runnerData?.section_id]?.event_status;
      }
    }

    /*

  if (
    eventDetails !== null &&
    eventDetails !== undefined &&
    eventDetails.evt_status == "OPEN"
  ) {
    if (
      matchOdds !== null &&
      matchOdds !== undefined &&
      matchOdds[runnerData?.section_id]?.section_status == "ACTIVE"
    ) {
      console.log(
        "matchOdds->",
        matchOdds[runnerData?.section_id]?.section_status
      );
    } else {
      returnObj.status = false;

      if (
        matchOdds !== null &&
        matchOdds[runnerData?.section_id]?.section_status !== ""
      ) {
        console.log(
          "matchOdds->",
          matchOdds[runnerData?.section_id]?.section_status
        );
        returnObj.displayTxt =
          matchOdds[runnerData?.section_id]?.section_status;
        console.log(
          "matchOdds->",
          matchOdds[runnerData?.section_id]?.section_status
        );
      }
    }
  } else {
    returnObj.status = false;
    returnObj.displayTxt = eventDetails.evt_status;
  }*/

    return returnObj;
  }

  function GetImageName(runnerData) {
    let link = `https://bp-silks.lhre.net/saddle/au/${runnerData.sort_priority}.svg`;

    if (eventDetails.countryCode.toLowerCase() == "au") {
      link = `https://bp-silks.lhre.net/saddle/au/${runnerData.sort_priority}.svg`;
    } else if (eventDetails.countryCode.toLowerCase() == "gb") {
      link = `https://bp-silks.lhre.net/saddle/uk/${runnerData.sort_priority}.svg`;
    }

    return link;
  }

  function DisplayOddRate(section_id) {
    let tt = matchOdds;
    if (matchOdds !== null && matchOdds !== undefined) {
      let record = matchOdds[section_id];
      if (record !== null && record !== undefined && record !== "") {
        r1b3 = record.r1b3;
        r1b2 = record.r1b2;
        r1b = record.r1b;
        r1l = record.r1l;
        r1l2 = record.r1l2;
        r1l3 = record.r1l3;

        rate1 = record.rate1;
        rate2 = record.rate2;
        rate3 = record.rate3;
        rate4 = record.rate4;
        rate5 = record.rate5;
        rate6 = record.rate6;
        rowStatus = record.event_status;
        isWinner = record.is_winner;
      }

      /*Object.entries(matchOdds).map(([key, value]) => (
                if(key === section_id) {

                }
                <p key={key}>
                  {key}: {value}
                </p>
              ));
              */
    }

    return 0;
  }

  return (
    <div className="table-box-body">
      {eventDetails.game_type == 4 ? (
        <Tooltip
          id="my-tooltip"
          place="right"
          style={{
            backgroundColor: "#000",
            color: "#fff",
            zIndex: 1000
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}></div>
        </Tooltip>
      ) : (
        ""
      )}
      <div className="tb-content">
        <div
          className="market-titlebar"
          style={{ display: horseArray.length >= 2 ? "" : "none" }}
        >
          <p className="market-name">
            <span className="market-name-badge">
              <i className="market-name-icon">
                <img
                  src="../assets/images/time-img.jpeg"
                  style={{
                    marginTop: "-8px",
                    marginLeft: "-1px",
                    width: "16px",
                    height: "16px"
                  }}
                />
              </i>
              <span>COMBINED -{status}</span>
              <span style={{ textTransform: "initial" }}>(MaxBet: 50K) </span>
            </span>
            <span className="rules-badge" onClick={() => showRules()}>
              <i className="fa fa-info-circle"></i>
            </span>
          </p>
          <div className="market-overarround">
            <span></span>
            <strong>Back</strong>
          </div>
          <div className="market-overarround market-overarround-lay">
            <strong>Lay</strong>
          </div>
        </div>

        <div
          className="market-runners"
          style={{ display: horseArray.length >= 2 ? "" : "none" }}
        >
          <div className="runner-runner">
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <div style={{ float: "left", marginLeft: "10px" }}>
                            <span
                              style={{
                                marginBottom: "0px",
                                fontSize: "16px",
                                fontWeight: "600",
                                whiteSpace: "normal"
                              }}
                              className="clippable-spacer"
                            >
                              {jtText}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a className="price-price price-back">
                <div id="runner2b3span">
                  <span
                    className="price-odd"
                    style={{ fontSize: "19px" }}
                  ></span>
                  <span className="price-amount"></span>
                </div>
              </a>

              <a className="price-price price-back">
                <div id="runner2b2span">
                  <span
                    className="price-odd"
                    style={{ fontSize: "19px" }}
                  ></span>
                  <span className="price-amount"></span>
                </div>
              </a>

              <a
                className="price-price price-back mb-show"
                style={{ backgroundColor: "rgb(141, 210, 240)" }}
                onClick={() =>
                  showBetSlipJT(
                    "b",
                    jtText,
                    { horseArray },
                    jodiBack.toFixed(2)
                  )
                }
              >
                <div>
                  <span
                    className="price-odd"
                    style={{ fontSize: "19px" }}
                    id="runner1b_combined"
                  >
                    {jodiBack.toFixed(2)}
                  </span>
                  <span className="price-amount"></span>
                </div>
              </a>

              <a
                className="price-price price-lay ml-4 mb-show"
                style={{ backgroundColor: "rgb(254, 175, 178)" }}
                onClick={() =>
                  showBetSlipJT("l", jtText, { horseArray }, jodiLay.toFixed(2))
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "19px" }}>
                    {jodiLay.toFixed(2)}
                  </span>
                  <span className="price-amount"></span>
                </div>
              </a>

              <a className="price-price price-lay">
                <div id="runner1l2span">
                  <span
                    className="price-odd"
                    style={{ fontSize: "19px" }}
                  ></span>
                  <span className="price-amount"></span>
                </div>
              </a>

              <a className="price-price price-lay mr-4">
                <div id="runner1l3span">
                  <span
                    className="price-odd"
                    style={{ fontSize: "19px" }}
                  ></span>
                  <span className="price-amount"></span>
                </div>
              </a>

              {/*<div
                className="suspended-overlap"
                style={{ display: status == "OPEN" ? "none" : "" }}
              >
                {status}
              </div>*/}
            </div>
          </div>
        </div>

        <div className="market-titlebar">
          <p className="market-name">
            <span className="market-name-badge">
              <i className="market-name-icon">
                <img
                  src="../assets/images/time-img.jpeg"
                  style={{
                    marginTop: "-8px",
                    marginLeft: "-1px",
                    width: "16px",
                    height: "16px"
                  }}
                />
              </i>

              <span>{eventDetails.matchSummaryText4}</span>

              <span style={{ textTransform: "initial" }}>(MaxBet: 50K) </span>
            </span>{" "}
            <span className="rules-badge" onClick={() => showRules()}>
              <i className="fa fa-info-circle"></i>
            </span>
          </p>
          <div className="market-overarround">
            <span></span>
            <strong>Back</strong>
          </div>
          <div className="market-overarround market-overarround-lay">
            <strong>Lay</strong>
          </div>
        </div>

        {betfair_runners !== null &&
          betfair_runners !== undefined &&
          betfair_runners !== "" &&
          betfair_runners.length > 0 &&
          betfair_runners.map((runnerData) => (
            //DisplayOddRate(runnerData.section_id)

            <div
              className="market-runners"
              style={{
                backgroundColor:
                  matchOdds && matchOdds[runnerData.section_id]?.is_winner === 1
                    ? "#b7f777"
                    : ""
              }}
            >
              <div className="runner-runner">
                {runnerData.game_type === 4 && (
                  <span
                    //className="ml-2 mr-2 selector"
                    className={getCss(runnerData.section_id, horseArray)}
                    onClick={() =>
                      selectUnsellectHorse(
                        runnerData.section_id,
                        runnerData.sort_priority,
                        runnerData.runner_name
                      )
                    }
                  ></span>
                )}

                {/*runnerData.game_type === 4 && (
                  <img
                    src={`https://bf-silks.009901.xyz/proxy/${runnerData.colours_filename}`}
                />
                )*/}

                <img
                  src={GetImageName(runnerData)}
                  style={{ height: "21px", marginTop: "16px" }}
                />

                <h3 className="runner-name">
                  <div className="runner-info">
                    <span className="clippable runner-display-name">
                      {eventDetails == 4 ? (
                        <h4
                          data-toggle="tooltip"
                          data-placement="top"
                          data-html="true"
                          title=""
                          className="clippable-spacer"
                          data-original-title="Jockey: <b><?=$jockey_name;?></b><br>Trainer:
                                 <b><?=$trainer_name;?></b><br>Age / Weigth: <b><?=$age;?>/<?=$weight_value;?></b>
                                 <br>Days since last run: <b><?=$days_since_last_run;?></b><br>Wearing: 
                                 <b><?=$wearing;?></b>"
                        ></h4>
                      ) : (
                        <h4
                          title=""
                          className="clippable-spacer"
                          data-tooltip-html={`
                          <div>
                            Jockey:<b> ${runnerData.jockey_name}</b><br/>
                            Trainer:<b> ${runnerData.trainer_name}</b><br/>
                            Age/Weight:<b> ${runnerData.age}/${runnerData.weight_value}</b><br/>
                            Days Since last run:<b> ${runnerData.days_since_last_run}</b><br/>
                            Wearing:<b> ${runnerData.wearing}</b><br/>
                          </div>
                        `}
                          data-tooltip-id="my-tooltip"
                        >
                          <div>
                            <div> {runnerData.runner_name}</div>
                            <div>
                              {" "}
                              <span
                                style={{ fontWeight: "normal", opacity: 0.9 }}
                              >
                                {runnerData.jockey_name}
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              color:
                                ShowBook(runnerData.section_id) >= 0
                                  ? "green"
                                  : "red"
                            }}
                          >
                            {ShowBook(runnerData.section_id)}
                          </div>
                        </h4>
                      )}
                    </span>
                  </div>
                </h3>

                <div className="price-row-box-new">
                  <a
                    className="price-price price-back"
                    onClick={() =>
                      showBetSlip(
                        "b",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1b3
                      )
                    }
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1b3}
                        rate={matchOdds[runnerData.section_id]?.rate3}
                        oddtype="b1"
                      />
                    )}
                  </a>

                  <a
                    className="price-price price-back"
                    onClick={() =>
                      showBetSlip(
                        "b",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1b2
                      )
                    }
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1b2}
                        rate={matchOdds[runnerData.section_id]?.rate2}
                        oddtype="b2"
                      />
                    )}
                  </a>

                  <a
                    className="price-price price-back mb-show"
                    onClick={() =>
                      showBetSlip(
                        "b",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1b
                      )
                    }
                    style={{ backgroundColor: "rgb(141, 210, 240)" }}
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1b}
                        rate={matchOdds[runnerData.section_id]?.rate1}
                        oddtype="b"
                      />
                    )}
                  </a>

                  <a
                    className="price-price price-lay ml-4 mb-show"
                    onClick={() =>
                      showBetSlip(
                        "l",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1l
                      )
                    }
                    style={{ backgroundColor: "rgb(254, 175, 178)" }}
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1l}
                        rate={matchOdds[runnerData.section_id]?.rate4}
                        oddtype="l"
                      />
                    )}
                  </a>

                  <a
                    className="price-price price-lay"
                    onClick={() =>
                      showBetSlip(
                        "l",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1l2
                      )
                    }
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1l2}
                        rate={matchOdds[runnerData.section_id]?.rate5}
                        oddtype="l1"
                      />
                    )}
                  </a>

                  <a
                    className="price-price price-lay mr-4"
                    onClick={() =>
                      showBetSlip(
                        "l",
                        runnerData.runner_name,
                        runnerData.section_id,
                        matchOdds[runnerData.section_id]?.r1l3
                      )
                    }
                  >
                    {matchOdds && (
                      <DisplayOdd
                        odd={matchOdds[runnerData.section_id]?.r1l3}
                        rate={matchOdds[runnerData.section_id]?.rate6}
                        oddtype="l2"
                      />
                    )}
                  </a>

                  <div
                    className="suspended-overlap"
                    style={{
                      display:
                        getCurrentStatus(matchOdds, eventDetails, runnerData)[
                          "status"
                        ] == true
                          ? "none"
                          : "block"
                    }}
                  >
                    {
                      getCurrentStatus(matchOdds, eventDetails, runnerData)[
                        "displayTxt"
                      ]
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default HrGrMatchOdd;
